module.exports = __webpack_public_path__ + "img/tms.c777812a.png";